import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';

import { EmailValidator } from '../../core';
import { Administrator } from './administrator.model';

@Injectable()
export class AdministratorFormService {
  constructor(private fb: FormBuilder) {}

  getForm(administrator: Administrator = new Administrator()): FormGroup {
    return this.fb.group({
      _id: [administrator._id],
      name: [administrator.name, Validators.required],
      email: [administrator.email, [Validators.required, EmailValidator]],
      passwordGroup: this.fb.group({
        password: ['', (typeof administrator._id == 'undefined') ? Validators.required : null],
        confirm: ['', (typeof administrator._id == 'undefined') ? Validators.required : null]
      }, { validator: this.passwordMatcher }),
      role: [administrator.role],
      active: [administrator.active]
    });
  }

  private passwordMatcher(c: AbstractControl) {
    if (c.get('password').value == '' || c.get('confirm').value == '') {
      return null;
    }
    
    return c.get('password').value === c.get('confirm').value ? null : { nomatch: true };
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/administrators/shared/administrator-form.service.ts